import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c8d68e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "orders-show font-inter pb-20 md:py-6 enter-content-animation"
}
const _hoisted_2 = { class: "flex items-center gap-4 mb-6 sticky top-0 bg-white/80 backdrop-blur z-30 py-2 border-b" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15 18-6-6 6-6" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "text-xs text-gray-400 font-medium uppercase tracking-wider" }
const _hoisted_7 = { class: "ml-auto" }
const _hoisted_8 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_9 = { class: "col-span-12 lg:col-span-8 flex flex-col gap-4" }
const _hoisted_10 = { class: "bg-white rounded-3xl p-6 border box-shadow" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-lg font-bold mb-4 flex items-center gap-2\" data-v-8c8d68e0><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-8c8d68e0><path d=\"M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z\" data-v-8c8d68e0></path><path d=\"M3 6h18\" data-v-8c8d68e0></path><path d=\"M16 10a4 4 0 0 1-8 0\" data-v-8c8d68e0></path></svg> Itens do Pedido </h2>", 1)
const _hoisted_12 = { class: "flex flex-col gap-4" }
const _hoisted_13 = { class: "flex gap-4 flex-1" }
const _hoisted_14 = { class: "h-12 w-12 rounded-xl bg-gray-50 flex items-center justify-center border overflow-hidden" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "text-gray-300"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "18",
  x: "3",
  y: "3",
  rx: "2",
  ry: "2"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "9",
  r: "2"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }, null, -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { class: "text-xs text-gray-400" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-gray-500 italic mt-1"
}
const _hoisted_24 = {
  key: 1,
  class: "text-xs text-red-500 font-semibold mt-1"
}
const _hoisted_25 = { class: "flex flex-col items-end gap-2" }
const _hoisted_26 = { class: "font-bold text-gray-700" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "mt-6 p-4 bg-yellow-50 rounded-2xl border border-yellow-100 italic text-sm text-yellow-800"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold block mb-1 not-italic text-xs uppercase opacity-60" }, "Observações:", -1))
const _hoisted_30 = { class: "bg-white rounded-3xl p-6 border box-shadow" }
const _hoisted_31 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col gap-1"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold uppercase tracking-wider" }, "Cliente", -1))
const _hoisted_34 = { class: "font-bold text-gray-800" }
const _hoisted_35 = { class: "text-xs text-gray-500" }
const _hoisted_36 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold uppercase tracking-wider" }, "Local", -1))
const _hoisted_38 = { class: "font-bold text-gray-800" }
const _hoisted_39 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_40 = { class: "col-span-12 lg:col-span-4 flex flex-col gap-4" }
const _hoisted_41 = { class: "bg-zinc-900 rounded-3xl p-6 text-white box-shadow" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold mb-6 flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 2v20" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
  ]),
  /*#__PURE__*/_createTextVNode(" Resumo de Pagamento ")
], -1))
const _hoisted_43 = { class: "flex flex-col gap-4 mb-6" }
const _hoisted_44 = { class: "flex justify-between items-center opacity-70 text-sm" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Subtotal", -1))
const _hoisted_46 = {
  key: 0,
  class: "flex justify-between items-center text-red-400 text-sm"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1))
const _hoisted_48 = {
  key: 1,
  class: "flex justify-between items-center opacity-70 text-sm"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Entrega", -1))
const _hoisted_50 = { class: "flex justify-between items-center pt-4 border-t border-white/10" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-lg" }, "Total", -1))
const _hoisted_52 = { class: "font-bold text-2xl text-success" }
const _hoisted_53 = { class: "bg-white/5 rounded-2xl p-4 flex flex-col gap-3" }
const _hoisted_54 = { class: "flex items-center justify-between text-xs" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-50 uppercase font-bold" }, "Método", -1))
const _hoisted_56 = { class: "font-bold uppercase" }
const _hoisted_57 = { class: "flex items-center justify-between text-xs" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-50 uppercase font-bold" }, "Status", -1))
const _hoisted_59 = { class: "flex flex-col gap-3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 9V2h12v7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "8",
    height: "5",
    x: "8",
    y: "11"
  })
], -1))

import { } from 'vue';
import { apiBaseUrl } from '@/global/state/GlobalState';
import axiosClient from '@/api/axios';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersShow',
  props: {
    order: {},
    setOrder: { type: Function }
  },
  setup(__props: any) {

const props = __props
const toast = useToast()

const statusTranslations: any = {
    'PENDING': {label: 'pendente', color:'#918373'},
    'PREPARING': {label: 'preparando', color:'#FF9B3D'},
    'PREPARED': {label: 'preparado', color:'#59A6F8'},
    'DELIVERED': {label: 'entregue', color: '#00c9a7'},
    'CANCELED': {label: 'cancelado', color:'#F83535'},
    'COMPLETED': {label: 'concluído', color: '#00c9a7'},
}

const paymentMethodTranslations: any = {
    'card': 'Cartão',
    'pix': 'PIX',
    'cash': 'Dinheiro',
    'credit_card': 'C. Crédito',
    'debit_card': 'C. Débito',
}

const paymentStatusTranslations: any = {
    'pending': 'Pendente',
    'paid': 'Pago',
    'refunded': 'Reembolsado',
    'canceled': 'Cancelado',
    'processing': 'Processando',
}

async function updateStatus(newStatus: string) {
    try {
        await axiosClient.patch(`/orders/${props.order.id}`, { status: newStatus })
        toast.success(`Status atualizado para ${statusTranslations[newStatus].label}`)
        props.setOrder({ ...props.order, status: newStatus })
    } catch (error: any) {
        const message = error.response?.data?.errors?.[0]?.message || "Erro ao atualizar pedido"
        toast.error(message)
    }
}

async function cancelOrder() {
    if (!confirm('Tem certeza que deseja cancelar este pedido?')) return

    try {
        await axiosClient.patch(`/orders/${props.order.id}`, { status: 'CANCELED' })
        toast.success("Pedido cancelado com sucesso")
        props.setOrder({ ...props.order, status: 'CANCELED' })
    } catch (error: any) {
        const message = error.response?.data?.errors?.[0]?.message || "Erro ao cancelar pedido"
        toast.error(message)
    }
}

function reprintReceipt() {
    window.print()
}

async function cancelItem(item: any) {
    if (!confirm(`Deseja cancelar "${item.productName || item.product?.name}"?`)) return

    try {
        await axiosClient.patch(`/orders/${props.order.id}/items/${item.id}/cancel`)
        toast.success("Item cancelado com sucesso")
        // Update the item in the order
        const updatedOrder = { ...props.order }
        const itemIndex = updatedOrder.items.findIndex((i: any) => i.id === item.id)
        if (itemIndex !== -1) {
            updatedOrder.items[itemIndex] = { ...updatedOrder.items[itemIndex], canceledAt: new Date() }
        }
        props.setOrder(updatedOrder)
    } catch (error: any) {
        const message = error.response?.data?.errors?.[0]?.message || "Erro ao cancelar item"
        toast.error(message)
    }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.order)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOrder(null))),
            class: "p-2 hover:bg-gray-100 rounded-full transition"
          }, _hoisted_4),
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_5, "Pedido #" + _toDisplayString(_ctx.order.id), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(new Date(_ctx.order.createdAt).toLocaleDateString('pt-BR')) + " às " + _toDisplayString(new Date(_ctx.order.createdAt).toLocaleTimeString('pt-BR').slice(0, 5)) + "h", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              style: _normalizeStyle({background: statusTranslations[_ctx.order.status]?.color}),
              class: "text-white text-[10px] uppercase font-bold p-2 px-3 rounded-xl shadow-sm"
            }, _toDisplayString(statusTranslations[_ctx.order.status]?.label), 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: _normalizeClass(["flex items-start justify-between py-3 border-b last:border-0", item.canceledAt ? 'opacity-50' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (item.product?.media?.[0])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(apiBaseUrl) + '/storage/' + item.product.media[0].path,
                              class: "w-full h-full object-cover"
                            }, null, 8, _hoisted_15))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_20))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h4", {
                          class: _normalizeClass(["font-bold text-gray-800", item.canceledAt ? 'line-through' : ''])
                        }, _toDisplayString(item.productName || item.product?.name || (item.variantId ? 'Variante' : 'Adicional')), 3),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(item.quantity) + "x " + _toDisplayString((item.promotionalPrice || item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1),
                        (item.notes)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Obs: " + _toDisplayString(item.notes), 1))
                          : _createCommentVNode("", true),
                        (item.canceledAt)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Cancelado"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(((item.promotionalPrice || item.price) * item.quantity).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1),
                      (!item.canceledAt && (_ctx.order.status === 'PENDING' || _ctx.order.status === 'PREPARING'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (cancelItem(item)),
                            class: "text-xs font-bold text-red-500 hover:text-red-700 transition"
                          }, " Cancelar ", 8, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]),
              (_ctx.order.notes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createTextVNode(" \"" + _toDisplayString(_ctx.order.notes) + "\" ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (_ctx.order.customer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.order.customer.name), 1),
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.order.customer.phone || 'Sem telefone'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order.tab)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("p", _hoisted_38, "Mesa " + _toDisplayString(_ctx.order.tab.number), 1),
                      (_ctx.order.tab.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.order.tab.name), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("span", null, _toDisplayString(_ctx.order.subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                ]),
                (_ctx.order.discount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("span", null, "-" + _toDisplayString(_ctx.order.discount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order.deliveryFee)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("span", null, _toDisplayString(_ctx.order.deliveryFee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.order.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("span", _hoisted_56, _toDisplayString(paymentMethodTranslations[_ctx.order.paymentMethod] || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.order.paymentStatus === 'paid' ? 'text-success' : 'text-yellow-400', "font-bold uppercase"])
                  }, _toDisplayString(paymentStatusTranslations[_ctx.order.paymentStatus]), 3)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              (_ctx.order.status === 'PENDING')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (updateStatus('PREPARING'))),
                    class: "w-full bg-primary text-white p-4 rounded-2xl font-bold hover:bg-opacity-90 transition"
                  }, " Aceitar e Preparar "))
                : _createCommentVNode("", true),
              (_ctx.order.status === 'PREPARING')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (updateStatus('PREPARED'))),
                    class: "w-full bg-primary text-white p-4 rounded-2xl font-bold hover:bg-opacity-90 transition"
                  }, " Marcar como Pronto "))
                : _createCommentVNode("", true),
              (_ctx.order.status === 'PREPARED')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (updateStatus('DELIVERED'))),
                    class: "w-full bg-primary text-white p-4 rounded-2xl font-bold hover:bg-opacity-90 transition"
                  }, " Entregar / Concluir "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: reprintReceipt,
                class: "w-full bg-blue-50 p-4 rounded-2xl font-bold text-blue-600 border border-blue-100 hover:bg-blue-100 transition flex items-center justify-center gap-2"
              }, [
                _hoisted_60,
                _createTextVNode(" Reimprimir ")
              ]),
              (_ctx.order.status !== 'CANCELED' && _ctx.order.status !== 'COMPLETED' && _ctx.order.status !== 'DELIVERED')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: cancelOrder,
                    class: "w-full bg-red-50 p-4 rounded-2xl font-bold text-red-500 border border-red-100 hover:bg-red-100 transition"
                  }, " Cancelar Pedido "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})